// extracted by mini-css-extract-plugin
export default {"secondaryProduct":"SecondaryProduct_secondaryProduct__HWZvl","description":"SecondaryProduct_description__4sSB4"};